import * as React from 'react';
import footerLogo from '../../images/Edenred_Digital-use.png';

const Footer =()=> {
     
        return (
            <footer>
                <div className="container-fluid">
                    <div className="d-flex justify-content-center align-items-center">
                        <figure className="mr-3">
                            <img className="footerLogo" src={footerLogo} />
                        </figure>
                        <p> Dirección Comercial: Alferez Hipólito Bouchard 4169/4191, 7° Piso, Munro, Buenos Aires, Argentina. Tel 0810 999 1400.</p>
                    </div>
                    <div className="footer-copy">
                        <p>© 2020 Edenred Argentina. Todos los derechos reservados.</p>
                    </div>
                </div>
            </footer>
        )
    }
    export default Footer